module.exports = __webpack_public_path__ + "static/andrew-c72bac922d730d6fcbd8278ceeeff5ff.png";